// External addresses the contest page links to. Keep them plain https URLs.

// The public contest site: full details of the contest and its prizes (and past winners).
// Opened in a new tab from the contest page.
export const CONTEST_SITE_URL = 'https://contest.sohozkaj.com/';

// SohozKaj's YouTube channel (as linked in the sohozkaj.com footer). `sub_confirmation=1` makes YouTube
// show its "Subscribe" prompt as soon as the channel opens — used by the "subscribe" bonus task.
export const YOUTUBE_SUBSCRIBE_URL = 'https://www.youtube.com/@SohozKaj?sub_confirmation=1';

// SohozKaj's TikTok account — the "follow on TikTok" bonus task opens it.
export const TIKTOK_PROFILE_URL = 'https://www.tiktok.com/@sohozkaj';

// The three mobile apps behind the "install" and "review on Play Store" bonus tasks. `key` is the suffix the backend
// uses for the claim activity (install_<key> / review_<key>, see sohozkaj-backend/src/services/contestApps.js) and the
// name of the app under contest.earn.apps.<key>; `storeUrl` is its Google Play page.
export const CONTEST_APPS = [
    { key: 'app', storeUrl: 'https://play.google.com/store/apps/details?id=com.sohozkaj.app' },
    { key: 'studio', storeUrl: 'https://play.google.com/store/apps/details?id=com.sohozkaj.studio' },
    { key: 'eaipe', storeUrl: 'https://play.google.com/store/apps/details?id=com.eaipe.app' },
];

// Browser extension pages where owners write a review (bonus tasks ext_chrome / ext_firefox)
export const CHROME_EXTENSION_URL = 'https://chromewebstore.google.com/detail/fddapaeieojijagpdmmaihieeiikhnbf?utm_source=item-share-cb';
export const FIREFOX_ADDON_URL = 'https://addons.mozilla.org/en-US/firefox/addon/sohozkaj-autofill/';
